import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from '@components/Link';
import s from './ArticlesCardMobile.css';
import moment from 'moment';

class ArticlesCardMobile extends Component {
  renderTemplate() {
    return (
      <div key={this.props.title} className={s.article_card_container}>
        <div className={s.article_card_image}>
          <img src={`${this.props.imageUrl}?w=640`}/>
        </div>
        <div className={s.textContainer}>
          <div
            // className={s.article_card_title}
            className={
              this.props.cardSmall
                ? `${s.article_card_title} ${s.card_small_font}`
                : `${s.article_card_title}`
            }
          >
            {this.props.title}
          </div>
          <div
            // className={s.article_card_date}
            className={
              this.props.cardSmall
                ? `${s.article_card_date} ${s.date_small_font}`
                : `${s.article_card_date}`
            }
          >
            {moment(this.props.date).format('MMMM, DD YYYY - H:MM')} WIB
          </div>
        </div>
      </div>
    );
  }

  render() {
    const serverSide = this.props.serverSide || false;

    return (
      <>
        {serverSide ? (
          <a href={`/articles/${this.props.id}`}>{this.renderTemplate()}</a>
        ) : (
          <Link to={`/articles/${this.props.id}`}>{this.renderTemplate()}</Link>
        )}
      </>
    );
  }
}

export default withStyles(s)(ArticlesCardMobile);
